import React from "react";
import { Header } from "./Header/Header";
import backgroundImg from "../../assets/images/background-image.png";
import { Footer } from "./Footer/Footer";
import MainSection from "./MainSection/MainSection";
import { Home } from "./Home/Home";
export function OfflineIndex(){
    return(
        <div style={{ backgroundImage: `url(${backgroundImg})`, backgroundSize: "cover", backgroundPosition: "center", minHeight: "100vh", padding:"30px 0px"}}>
            <Header/>
            <Home/>
            <MainSection/>
            <Footer/>
        </div>
    )
}